import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getVideos } from "./videosAPI";
const initialState = {
  videos: [],
  lastPage: 1,
  isLoading: false,
  isError: false,
  error: "",
};

export const fetchVideos = createAsyncThunk("videos/fetchVideos", async ({ tags, search, author, page, limit }) => {
  const videos = await getVideos(tags, search, author, page, limit);
  return videos;
});

const VideosSlice = createSlice({
  name: "videos",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideos.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.videos = action.payload.data;
        state.lastPage = action.payload.lastPage;
        state.isLoading = false;
        state.isError = false;
        state.error = "";
      })
      .addCase(fetchVideos.rejected, (state, action) => {
        state.videos = [];
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default VideosSlice.reducer;
